import React, { useState } from 'react';
import Table from 'cccisd-graphql-table';
import Loader from 'cccisd-loader';
import Modal from 'cccisd-modal';

import DevDeploy from './DevDeploy';
import ProductionDeploy from './ProductionDeploy';

import tableQuery from './deployTable.graphql';
import style from './style.css';
import { JobStatus, ModalView, Runtime } from '../devopsRenders.js';

const DeployTable = props => {
    const [isLoading, setIsLoading] = useState(false);

    const columns = [
        { name: 'jobId', label: 'ID', sort: true, filter: true },
        { name: 'app', label: 'App', sort: true, filter: true },
        { name: 'tag', label: 'Tag', sort: true, filter: true },
        { name: 'context', label: 'Context', sort: true, filter: true },
        { name: 'consoleOutput', label: 'Console Output', sort: true, filter: true, render: ModalView },
        { name: 'status', label: 'Status', sort: true, filter: true, render: JobStatus },
        { name: 'initiator.username', label: 'Run By', sort: true, filter: true },
        { name: 'runtime', label: 'Runtime', sort: true, filter: true, render: Runtime },
        { name: 'queuedAt', label: 'Queued', sort: true, filter: true },
        { name: 'completedAt', label: 'Completed', sort: true, filter: true },
    ];

    const forceUpdate = async () => {
        setIsLoading(true);
        setIsLoading(false);
    };

    return (
        <Loader loading={isLoading} removeChildren>
            {!isLoading && (
                <div>
                    <div className={style.launchbutton}>
                        <Modal
                            trigger={
                                <button className={style.button + ' btn btn-primary'} type="button">
                                    Dev Deployment
                                </button>
                            }
                            title="Dev Deployment"
                            headerStyle={{
                                backgroundColor: '#007298',
                                color: '#fff',
                            }}
                            formAutoFocus
                            afterClose={() => forceUpdate()}
                            render={({ closeModal }) => <DevDeploy closeModal={closeModal} />}
                        />
                        <Modal
                            trigger={
                                <button className={style.button + ' btn btn-primary'} type="button">
                                    Production Deployment
                                </button>
                            }
                            title="Production Deployment"
                            headerStyle={{
                                backgroundColor: '#007298',
                                color: '#fff',
                            }}
                            formAutoFocus
                            afterClose={() => forceUpdate()}
                            render={({ closeModal }) => <ProductionDeploy closeModal={closeModal} />}
                        />
                    </div>
                    <Table
                        query={tableQuery}
                        rowKey="jobId"
                        orderBy="jobId"
                        isAscentOrder={false}
                        columns={columns}
                        renders={{ JobStatus }}
                        columnRenderParams={{
                            consoleOutput: { buttontext: 'Console', title: 'Console Output' },
                        }}
                    />
                </div>
            )}
        </Loader>
    );
};

export default DeployTable;
